<ng-container *transloco="let t">
  @if (isXsComponent) {
    <img
      [src]="isFavorite() && !isPreviewComponent ? 'assets/img/svg/save-btn-xs-filled.svg' :
      'assets/img/svg/save-btn-xs.svg'"
      [alt]="t('app.common.save')" (click)="addToFavoritesButtonClicked($event)"/>
  } @else {
    @if (asButton) {
      <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--grey-neutral-800)'"
                      [text]="t('app.common.save')|uppercase" [borderColor]="'var(--teal-500)'"

                      [trailingIcon]="isFavorite() && isAuthenticated
                 ? 'assets/icons/icons-alt/bookmark-filled.svg'
                 : 'assets/icons/icons-alt/bookmark-outlined.svg'"></app-button-alt>
    } @else {
      @if (isFavorite() && !isPreviewComponent) {
        <div class="d-flex cursor-pointer pe-3 align-items-center" (click)="addToFavoritesButtonClicked($event)">
          <span class="text-uppercase fs-14 pe-1">{{t('app.common.save')}}</span>
          <img src="assets/icons/icons-alt/bookmark-filled.svg" alt="{{t('app.common.save')}}" class="fav-icon">
        </div>
      } @else {
        <div class="d-flex cursor-pointer pe-3 align-items-center" (click)="addToFavoritesButtonClicked($event)">
          <span class="text-uppercase fs-14 pe-1">{{t('app.common.save')}}</span>
          <img src="assets/icons/icons-alt/bookmark-outlined.svg" alt="{{t('app.common.save')}}" class="fav-icon">
        </div>
      }
    }
  }
</ng-container>
